"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var panel_placement_1 = require("./panel-placement");
require("./sis-panel.component.css");
var PanelComponent = /** @class */ (function () {
    function PanelComponent() {
        this._isOpened = false;
        this.isFloating = false;
        this.panelStyle = '';
        this.size = 0;
        this.id = '';
    }
    Object.defineProperty(PanelComponent.prototype, "styles", {
        get: function () {
            return this._styles;
        },
        set: function (value) {
            this._styles = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PanelComponent.prototype, "cssClasses", {
        get: function () {
            return this._cssClasses;
        },
        set: function (value) {
            this._cssClasses = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PanelComponent.prototype, "isOpened", {
        get: function () {
            return this._isOpened;
        },
        /**
         * State(opened or closed) of panel for toggling it.
         * @type {boolean}
         */
        set: function (isOpened) {
            this._isOpened = isOpened;
            this.setCssClasses();
        },
        enumerable: true,
        configurable: true
    });
    PanelComponent.prototype.ngOnInit = function () {
        if (this.isFloating) {
            this.panelStyle = 'sis-panel--floating ';
        }
        switch (this.panelPlacement) {
            case panel_placement_1.PanelPlacement.TOP:
                this.panelStyle += 'sis-panel-position--top';
                this.isVertical = true;
                break;
            case panel_placement_1.PanelPlacement.LEFT:
                this.panelStyle += 'sis-panel-position--left';
                this.isVertical = false;
                break;
            case panel_placement_1.PanelPlacement.RIGHT:
                this.panelStyle += 'sis-panel-position--right';
                this.isVertical = false;
                break;
            case panel_placement_1.PanelPlacement.BOTTOM:
                this.panelStyle += 'sis-panel-position--bottom';
                this.isVertical = true;
                break;
            default:
                throw new TypeError('Invalid panel placement was provided.');
        }
        this._styles = {
            height: this.isVertical ? this.size + "px" : '',
            width: this.isVertical ? '' : this.size + "px",
        };
        this.setCssClasses();
    };
    PanelComponent.prototype.setCssClasses = function () {
        if (this._isOpened) {
            this._cssClasses = this.panelStyle + ' sis-panel-open';
        }
        else {
            this._cssClasses = this.panelStyle + ' sis-panel-closed';
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], PanelComponent.prototype, "size", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], PanelComponent.prototype, "panelPlacement", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], PanelComponent.prototype, "isFloating", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PanelComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], PanelComponent.prototype, "isOpened", null);
    PanelComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-panel',
            template: require('./sis-panel.component.html'),
        })
        /**
         * Panel component is dynamic panel with dynamic content. *
         */
        ,
        __metadata("design:paramtypes", [])
    ], PanelComponent);
    return PanelComponent;
}());
exports.PanelComponent = PanelComponent;
//# sourceMappingURL=sis-panel.component.js.map